import React from 'react';
import Popup from '../Popups/Popup';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import LearningPlanExamSuccessPostTest from '../LearningPlans/LearningPlanExamSuccessPostTest';
import AssessmentResultsPopup from '../AssessmentResultsPopup/AssessmentResultsPopup';

export default class MyTranscript extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			course: {},
			testId: null,
			testVisible: false,
			testCompletedAt: null,
			assessmentPopupVisible: false
		};

		this.onHidePopup = this.onHidePopup.bind(this);
	}

	render() {
		// console.log('MyTranscript props', this.props, this.state);
		const {
			is_admin = false,
			personalData = {},
			user_assessments
		} = this.props;
		const { course, testVisible: testData } = this.state;
		return (
			<div className="my-transcript">
				<ul className="list-group">
					{' '}
					{this.renderUserAssessmentScores(user_assessments, personalData)}
				</ul>
				<ul className="list-group">{this.renderLearningPlans()}</ul>
				{is_admin && testData ? (
					<PopupWithUseClickOutside
						isPopupVisible={testData}
						onHidePopup={this.onHidePopup}
						style={{ maxWidth: '750px' }}
					>
						<Popup
							title={
								<h1 className="card-title">
									{course ? (
										<span>
											{I18n.t(testData.type.toLowerCase())}: {course.name}
										</span>
									) : (
										testData.title
									)}
								</h1>
							}
							onHidePopup={this.onHidePopup}
						>
							<LearningPlanExamSuccessPostTest
								{...testData}
								testId={this.state.testId}
								learning_plan={this.state.learning_plan}
								testCompletedAt={this.state.testCompletedAt}
								personalData={personalData}
								course={course}
								courses={this.props.courses}
								is_admin={is_admin}
							/>
						</Popup>
					</PopupWithUseClickOutside>
				) : null}
			</div>
		);
	}

	renderUserAssessmentScores(user_assessments, personalData) {
		if (!user_assessments || !user_assessments.length) {
			return null; // or handle the case where user_assessments is undefined or empty
		}

		const assessmentResults = user_assessments.map((assessment, index) => {
			const { template_type, data = {} } = assessment;

			if (
				data &&
				template_type === 'FINANCIAL_FITNESS' &&
				Object.keys(data.results).length > 0
			) {
				return (
					// Display assessment results in a table
					<div key={index} className="assessment-result">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th>{I18n.t('admin.scores')}</th>
									<th>{I18n.t('admin.date_completed')}</th>
									<th>{I18n.t('admin.results')}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>
										{/* Display financial fitness scores in a nested table */}
										<table className="table table-bordered">
											<thead>
												<tr>
													<th>{I18n.t('admin.financial_fitness')}</th>
													<th>{I18n.t('admin.aptitude')}</th>
													<th>{I18n.t('admin.behavior')}</th>
													<th>{I18n.t('admin.confidence')}</th>
												</tr>
											</thead>
											<tbody>
												<tr>
													{/* Map over score types and render score cells */}
													{[
														'FINANCIAL_FITNESS',
														'APTITUDE',
														'BEHAVIOR',
														'CONFIDENCE'
													].map((type) => {
														const scoreData =
															(Array.isArray(data.results) &&
																data.results.find(
																	(result) => result.type === type
																)) ||
															(!Array.isArray(data.results) &&
																data.results[type]
																? data.results[type]
																: null);

														return (
															<React.Fragment key={type}>
																{this.renderScoreCell(scoreData)}
															</React.Fragment>
														);
													})}
												</tr>
											</tbody>
										</table>
									</td>
									<td>{this.getDateCompleted(assessment)}</td>
									<td>
										{/* Display "See Results" link with an onClick handler */}
										<a
											href="#"
											onClick={(e) => {
												e.preventDefault();
												this.handleTestResultsClick();
											}}
										>
											{I18n.t('admin.see_results')}
										</a>
									</td>
								</tr>
							</tbody>
						</table>

						{/* AssessmentResultsPopup */}
						<AssessmentResultsPopup
							isVisible={this.state.assessmentPopupVisible}
							personalData={personalData}
							assessment={assessment}
							testCompletedAt={this.getDateCompleted()}
							onHide={() => this.setState({ assessmentPopupVisible: false })}
						/>
					</div>
				);
			}
			return null;
		});

		return (
			<div className="assessment-results" style={{ marginTop: '10px' }}>
				{assessmentResults.some((result) => result !== null) ? (
					<div>
						<h3>{I18n.t('admin.user_profile.user_checkups')}</h3>
						<div className="assessment-results-list">{assessmentResults}</div>
					</div>
				) : null}
			</div>
		);
	}

	getDateCompleted(assessment) {
		if (assessment && assessment.completed) {
			const { completed_at } = assessment;
			return completed_at
				? new Date(completed_at).toLocaleDateString()
				: I18n.t('admin.user_profile.assessment_not_available');
		}
		return I18n.t('admin.user_profile.assessment_not_completed');
	}

	renderScoreCell(scoreData) {
		if (!scoreData) {
			return (
				<React.Fragment>
					<td>{I18n.t('admin.user_profile_user.no_assessment_data')}</td>
				</React.Fragment>
			);
		}

		const { score } = scoreData;

		return (
			<React.Fragment>
				<td>{score && score.scaled}</td>
			</React.Fragment>
		);
	}

	handleTestResultsClick() {
		this.setState({
			assessmentPopupVisible: true
		});
	}

	renderLearningPlans() {
		const { is_admin = false, user_learning_plans = [] } = this.props;
		return user_learning_plans.map((user_learning_plan, index) => {
			const { learning_plan = {} } = user_learning_plan;
			const { name, learning_plan_sections } = learning_plan;
			const { learning_plan_items = [] } = learning_plan_sections[0];
			return (
				<li key={index} className="list-group-item">
					<h3 style={is_admin ? { margin: '0.25rem 0 0 0' } : {}}>{name}</h3>
					<ul className="list-group">
						{this.renderLearningPlanItems(learning_plan_items, learning_plan)}
					</ul>
				</li>
			);
		});
	}

	renderLearningPlanItems(learning_plan_items, learning_plan) {
		const { is_admin = false } = this.props;
		return learning_plan_items.map((learning_plan_item, index) => {
			if (learning_plan_item.learnable_type == 'Course') {
				const {
					learnable: course,
					pretest_user_assessments = [],
					posttest_user_assessments = []
				} = learning_plan_item;

				const { course_progress, image_url } = course;
				const content_progress = Math.round(course_progress * 100);
				return (
					<li
						key={index}
						className="list-group-item"
						style={is_admin ? { border: '0px', padding: '0px' } : {}}
					>
						<h4
							className="course-name"
							style={is_admin ? { marginTop: '1rem' } : {}}
						>
							<img
								src={image_url}
								className="img-thumbnail course-image"
							/>{' '}
							{course.name}
						</h4>
						<h6 className="content-progress" style={{ paddingTop: '0.75rem' }}>
							{I18n.t('content_progress')}: {content_progress}%
						</h6>
						{pretest_user_assessments.length ||
							posttest_user_assessments.length ? (
							<table
								className="table table-bordered"
								style={{
									tableLayout: 'fixed',
									marginTop: '15px',
									marginBottom: 0
								}}
							>
								<tbody>
									{this.renderTests(
										pretest_user_assessments,
										'pretest',
										course,
										learning_plan
									)}
									{this.renderTests(
										posttest_user_assessments,
										'posttest',
										course,
										learning_plan
									)}
								</tbody>
							</table>
						) : null}
					</li>
				);
			} else if (learning_plan_item.learnable_type == 'Exam') {
				var { learnable: exam, user_assessments = [] } = learning_plan_item;
				user_assessments = user_assessments.filter(
					(user_assessment) => user_assessment.completed
				);
				return (
					<li
						key={index}
						className="list-group-item"
						style={is_admin ? { border: '0px', padding: '0px' } : {}}
					>
						<h4
							className="course-name"
							style={is_admin ? { marginTop: '1rem' } : {}}
						>
							{exam.name}
						</h4>
						{user_assessments.length ? (
							<table
								className="table table-bordered"
								style={{
									tableLayout: 'fixed',
									marginTop: '15px',
									marginBottom: 0
								}}
							>
								<tbody>
									{this.renderTests(
										user_assessments,
										'exam',
										null,
										learning_plan
									)}
								</tbody>
							</table>
						) : null}
					</li>
				);
			}
		});
	}

	renderTests(tests, test_type, course, learning_plan) {
		const { is_admin = false } = this.props;
		return tests.map((test, _index) => {
			const learning_plan_item = this.findLearningPlanItem(learning_plan, test.learning_plan_item_id)
			// console.log('learning_plan_item', learning_plan_item, 'test', test);
			const completed_at = new Date(test.completed_at);
			return (
				<tr key={test.id}>
					<th scope="row">{I18n.t(test_type)}</th>
					<td>
						{completed_at.toLocaleDateString('en-us', {
							weekday: 'long',
							year: 'numeric',
							month: 'short',
							day: 'numeric'
						})}{' '}
						{completed_at.toLocaleTimeString('en-us', {
							hour: 'numeric',
							minute: 'numeric'
						})}
					</td>
					<td className="text-right">
						{is_admin ? (
							<a
								href="#"
								onClick={(e) => {
									e.preventDefault();
									this.setState({
										course: course,
										testId: test.id,
										testVisible: test.data,
										testCompletedAt: test.completed_at,
										learning_plan: learning_plan
									});
								}}
							>
								{test.score}% ({test.number_correct} correct out of{' '}
								{test.number_of_questions})
							</a>
						) : test_type != 'exam' || (test.score_released || learning_plan_item.learnable.score_released !== 'manual') ? (
							<div>
								{' '}
								{test.score}% ({test.number_correct} correct out of{' '}
								{test.number_of_questions})
							</div>
						) : (
							<div>{I18n.t('score_not_released')}</div>
						)}
					</td>
				</tr>
			);
		});
	}

	findLearningPlanItem(learning_plan, learnable_id) {
		const { learning_plan_sections } = learning_plan;
		const learning_plan_items = learning_plan_sections[0].learning_plan_items;
		return learning_plan_items.find(
			(learning_plan_item) => learning_plan_item.id === learnable_id
		);
	}

	onHidePopup() {
		this.setState({ testVisible: false });
	}
}
